import { connect } from 'react-redux';
import { DateRangeFilters } from '@mews-commander/legacy-form';
import { closeSidebar, submitFilterValues } from '../actions';

// @ts-expect-error $TSFixMeError: Property 'serviceId' does not exist on type '{}'.
export default connect(undefined, (dispatch, { serviceId }) => ({
    // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => void' is not assignable to parameter of type 'Action<any>'...
    onFocus: () => dispatch(closeSidebar(serviceId)),

    // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => void' is not assignable to parameter of type 'Action<any>'...
    onSubmit: (formValues: $TSFixMe) => dispatch(submitFilterValues(formValues, serviceId)),
}))(DateRangeFilters);
